export { PatientService } from './patient.service';
